module.exports = __webpack_public_path__ + "static/media/feedback.61db4154.svg";